import React, { lazy, Suspense, useEffect } from 'react';
import LoadingScreen from './LoadingScreen';
const ShikrapurPageContent = lazy(()=>import('./ShikrapurPageContent'));
const ProjectsNavbar = lazy(()=>import('./ProjectsNavbar'));
const Footer = lazy(()=>import('./Footer'));
const SubFooter = lazy(()=>import("./SubFooter"));
const Enquiry = lazy(()=>import("./Enquiry"));

export default function ShikrapurPage() {
    useEffect(()=>{
        window.scroll(0,0);
      },[]);
      return (
        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 row px-0 display-flex'>
            <Suspense fallback={<LoadingScreen />}>
              <ProjectsNavbar buttonOptions={[
                {label:"Know Us" , hrefLink:"#knowus"},
                {label:"Why Us" , hrefLink:"#whyus"},
                {label:"We Offer" , hrefLink:"#weoffer"},
                {label:"Amenities" , hrefLink:"#amenities"},
                {label:"Projects" , hrefLink:"/projects"}
              ]} />
                <ShikrapurPageContent />
                <SubFooter />
                <Footer />
                <Enquiry originOfEnquiry = "SHIKRAPUR - PUNE" />
            </Suspense>
        </div>
  )
}
